import YSlide from './Slide';

export { YSlide };
export default YSlide;
